import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout";
import { useAuth } from "../../context/AuthContext";
import { FiEdit2, FiTrash2, FiPlus } from "react-icons/fi";
import FormDataMapel from "./FormDataMapel";
import ConfirmDeleteModal from "../../components/modal/Delete";

export default function DataMapel() {
  const { token } = useAuth();
  const [mapel, setMapel] = useState([]);
  const [search, setSearch] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [selectedMapel, setSelectedMapel] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const fetchMapel = useCallback(async () => {
    try {
      const res = await axios.get("https://backend.smpn1kamal.sch.id/api/datamapel", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMapel(res.data);
    } catch {
      toast.error("Gagal mengambil data mapel");
    }
  }, [token]);

  useEffect(() => { fetchMapel(); }, [fetchMapel]);

  const handleDelete = async () => {
    try {
      setLoadingDelete(true);
      await axios.delete(`https://backend.smpn1kamal.sch.id/api/datamapel/${selectedId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Mapel berhasil dihapus");
      setOpenDelete(false);
      fetchMapel();
    } catch {
      toast.error("Gagal menghapus mapel");
    } finally {
      setLoadingDelete(false);
    }
  };

  const filteredMapel = mapel.filter((m) =>
    m.nama_mapel.toLowerCase().includes(search.toLowerCase()) ||
    (m.kode_mapel || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <AdminLayout>
      <div className="space-y-6">

        {/* HEADER */}
        <div className="space-y-3">
          <div className="hidden md:flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-indigo-600">Data Mata Pelajaran</h1>
              <p className="text-sm text-gray-500">SMPN 1 Kamal</p>
            </div>
            <button
              onClick={() => { setSelectedMapel(null); setOpenForm(true); }}
              className="flex items-center gap-2 bg-indigo-500 text-white px-5 py-2 rounded-full shadow-md hover:bg-indigo-600 transition"
            >
              <FiPlus /> Tambah
            </button>
          </div>
          <div className="md:hidden space-y-3">
            <div>
              <h1 className="text-2xl font-bold text-indigo-600">Data Mata Pelajaran</h1>
              <p className="text-sm text-gray-500">SMPN 1 Kamal</p>
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => { setSelectedMapel(null); setOpenForm(true); }}
                className="flex items-center gap-2 bg-indigo-500 text-white px-5 py-2 rounded-full shadow-md hover:bg-indigo-600 transition"
              >
                <FiPlus /> Tambah
              </button>
            </div>
          </div>
        </div>

        {/* CARD */}
        <div className="bg-white rounded-2xl shadow-md p-5">
          <div className="flex justify-end mb-5">
            <input
              type="text"
              placeholder="Cari mapel..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border rounded-full px-4 py-2 text-sm w-full md:w-72 focus:ring-2 focus:ring-indigo-400 outline-none"
            />
          </div>

          {/* DESKTOP */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-100 text-gray-600">
                <tr>
                  <th className="px-4 py-3 text-left">NO</th>
                  <th className="px-4 py-3 text-left">KODE MAPEL</th>
                  <th className="px-4 py-3 text-left">NAMA MAPEL</th>
                  <th className="px-4 py-3 text-center">AKSI</th>
                </tr>
              </thead>
              <tbody>
                {filteredMapel.map((m, i) => (
                  <tr key={m.id_mapel} className="border-t hover:bg-gray-50">
                    <td className="px-4 py-3">{i + 1}</td>
                    <td className="px-4 py-3">{m.kode_mapel || "-"}</td>
                    <td className="px-4 py-3 font-medium">{m.nama_mapel}</td>
                    <td className="px-4 py-3">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => { setSelectedMapel(m); setOpenForm(true); }}
                          className="w-8 h-8 flex items-center justify-center rounded-full bg-blue-50 text-blue-600 hover:bg-blue-100 transition"
                        >
                          <FiEdit2 size={13} />
                        </button>
                        <button
                          onClick={() => { setSelectedId(m.id_mapel); setOpenDelete(true); }}
                          className="w-8 h-8 flex items-center justify-center rounded-full bg-red-50 text-red-500 hover:bg-red-100 transition"
                        >
                          <FiTrash2 size={13} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {filteredMapel.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center py-6 text-gray-400">Data tidak ditemukan</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* MOBILE */}
          <div className="md:hidden space-y-3">
            {filteredMapel.map((m, i) => (
              <div key={m.id_mapel} className="border rounded-xl p-4 shadow-sm">
                <p className="font-semibold text-sm">{m.nama_mapel}</p>
                <p className="text-xs text-gray-500">Kode: {m.kode_mapel || "-"}</p>
                <p className="text-xs text-gray-400">No: {i + 1}</p>
                <div className="flex gap-2 mt-3">
                  <button
                    onClick={() => { setSelectedMapel(m); setOpenForm(true); }}
                    className="flex-1 bg-blue-500 text-white py-2 rounded-full text-sm font-medium hover:bg-blue-600 active:scale-95 transition"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => { setSelectedId(m.id_mapel); setOpenDelete(true); }}
                    className="flex-1 bg-red-500 text-white py-2 rounded-full text-sm font-medium hover:bg-red-600 active:scale-95 transition"
                  >
                    Hapus
                  </button>
                </div>
              </div>
            ))}
            {filteredMapel.length === 0 && (
              <p className="text-center py-4 text-gray-400">Data tidak ditemukan</p>
            )}
          </div>
        </div>

        <FormDataMapel
          open={openForm}
          onClose={() => setOpenForm(false)}
          onSuccess={fetchMapel}
          data={selectedMapel}
        />
        <ConfirmDeleteModal
          open={openDelete}
          onClose={() => setOpenDelete(false)}
          onConfirm={handleDelete}
          loading={loadingDelete}
          title="Hapus Mapel"
          description="Data mapel yang dihapus tidak dapat dikembalikan."
        />
      </div>
    </AdminLayout>
  );
}